// scrollToTarget.js

let isScrollingProgrammatically = false;
let onProgrammaticScrollEnd = null;

export function setScrollingProgrammatically(value) {
  isScrollingProgrammatically = value;

  if (!value && typeof onProgrammaticScrollEnd === 'function') {
    onProgrammaticScrollEnd();
  }
}

export function getScrollingProgrammatically() {
  return isScrollingProgrammatically;
}

export function registerProgrammaticScrollEnd(fn) {
  onProgrammaticScrollEnd = fn;
}


export function scrollToTarget(elems) {
    if (!elems.length) return;

    const DURATION = 900;
    const SCROLL_OFFSET = 32;

    const easeInOutCubic = (t) =>
        t < 0.5
            ? 4 * t * t * t
            : 1 - Math.pow(-2 * t + 2, 3) / 2;

    const scrollToPosition = (end) => {
        const start = window.pageYOffset;
        const distance = end - start;
        const startTime = performance.now();

        const prefersReducedMotion = window.matchMedia(
            '(prefers-reduced-motion: reduce)'
        ).matches;

        if (prefersReducedMotion) {
            window.scrollTo(0, end);
            return;
        }

        isScrollingProgrammatically = true;

        const step = (currentTime) => {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / DURATION, 1);

            window.scrollTo(
                0,
                start + distance * easeInOutCubic(progress)
            );

            if (progress < 1) {
                requestAnimationFrame(step);
            } else {
                isScrollingProgrammatically = false; // done
            }
        };

        requestAnimationFrame(step);
    };

    const getFallbackSection = (button) => {
        const currentSection = button.closest('section');
        if (!currentSection) return null;

        return currentSection.nextElementSibling?.tagName === 'SECTION'
            ? currentSection.nextElementSibling
            : currentSection.nextElementSibling?.closest('section');
    };

    elems.forEach((button) => {
        button.addEventListener('click', (event) => {
            event.preventDefault();

            let target = null;
            const value = button.getAttribute('data-scroll-target');

            if (value && value.includes('#')) {
                const id = value.split('#')[1];
                target = document.getElementById(id);
            }

            if (!target) {
                target = getFallbackSection(button);
            }

            if (!target) return;

            const end =
                target.getBoundingClientRect().top +
                window.pageYOffset -
                SCROLL_OFFSET;

            scrollToPosition(end);
        });
    });
}
